export default "__VITE_ASSET__CrJsUpCh__"